// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAnUlEQVR4nO2QMQrCQBBFX51NbWMp2uox7Gw8h22uYEguIZNKyB0lMIElTNzdGBvdB8PC8Gces5DJ/Cxn4Aa4QM5pbsgncQF6rQYoZ3IFcPey11jByRsaqzYuctqfZo8xki3QBURuRtDpfBQ74GEsaYHN5It8wYFEhgExlj2NniwRhC7qP70gRSRrCN6JZE2BJZJvCEb2QKVvJvMvvAD2WzaK/35kGAAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.validationlist {
  position: absolute;
  left: 0;
  z-index: 1;
  appearance: none;
  -moz-appearance: "none";
  -webkit-appearance: "none";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.7rem top 50%;
  background-size: 1rem auto;
}

@media (max-width: 375px) {
  .validationlist {
    background-position: right 0.5rem top 50%;
  }
}

@media (min-width:375px) and (max-width: 767px) {
  .validationlist {
    background-position: right 1rem top 50%;
  }
}

.warning {
  position: absolute;
  padding: 5px;
  border: 1px solid black;
  background: white;
  width: 250px;
  border-radius: 5px;
  animation: inAnimation 1s ease-in-out;
  z-index: 1;
}

.defaultvalueWarning {
  position: absolute;
  left: 20px;
}

.defaultvalueWarning::before {
  content: "";
  width: 0px;
  height: 0px;
  border-style: outset;
  border-width: 0px 10px 10px 10px;
  border-color: transparent transparent black transparent;
  display: inline-block;
  position: absolute;
  top: -29%;
  left: 0;
  right: 75%;
  margin: 0 auto;
}

@keyframes inAnimation {
  0% {
    opacity: 0;
    visibility: hidden;
  }

  25% {
    opacity: 1;
    visibility: visible;
  }

  50% {
    opacity: 1;
    visibility: visible;
  }

  75% {
    opacity: 1;
    visibility: visible;
  }

  100% {
    opacity: 1;
    visibility: visible;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/AddUser.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,yDAA2W;EAC3W,4BAA4B;EAC5B,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,gCAAgC;EAChC,uDAAuD;EACvD,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":[".validationlist {\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  appearance: none;\n  -moz-appearance: \"none\";\n  -webkit-appearance: \"none\";\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAnUlEQVR4nO2QMQrCQBBFX51NbWMp2uox7Gw8h22uYEguIZNKyB0lMIElTNzdGBvdB8PC8Gces5DJ/Cxn4Aa4QM5pbsgncQF6rQYoZ3IFcPey11jByRsaqzYuctqfZo8xki3QBURuRtDpfBQ74GEsaYHN5It8wYFEhgExlj2NniwRhC7qP70gRSRrCN6JZE2BJZJvCEb2QKVvJvMvvAD2WzaK/35kGAAAAABJRU5ErkJggg==\");\n  background-repeat: no-repeat;\n  background-position: right 0.7rem top 50%;\n  background-size: 1rem auto;\n}\n\n@media (max-width: 375px) {\n  .validationlist {\n    background-position: right 0.5rem top 50%;\n  }\n}\n\n@media (min-width:375px) and (max-width: 767px) {\n  .validationlist {\n    background-position: right 1rem top 50%;\n  }\n}\n\n.warning {\n  position: absolute;\n  padding: 5px;\n  border: 1px solid black;\n  background: white;\n  width: 250px;\n  border-radius: 5px;\n  animation: inAnimation 1s ease-in-out;\n  z-index: 1;\n}\n\n.defaultvalueWarning {\n  position: absolute;\n  left: 20px;\n}\n\n.defaultvalueWarning::before {\n  content: \"\";\n  width: 0px;\n  height: 0px;\n  border-style: outset;\n  border-width: 0px 10px 10px 10px;\n  border-color: transparent transparent black transparent;\n  display: inline-block;\n  position: absolute;\n  top: -29%;\n  left: 0;\n  right: 75%;\n  margin: 0 auto;\n}\n\n@keyframes inAnimation {\n  0% {\n    opacity: 0;\n    visibility: hidden;\n  }\n\n  25% {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  50% {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  75% {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  100% {\n    opacity: 1;\n    visibility: visible;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
